var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-footer',{attrs:{"tile":"","app":"","id":"dashboard-core-footer"}},[_c('v-col',{staticClass:"text-center"},[_vm._v(" © 2024 by "),_c('a',{attrs:{"href":"https://www.GrowthTech.ly"}},[_vm._v("GrowthTech")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }